"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IronCrossOptions = void 0;
/** IronCrossOptions.tsx
 *
 * Game Options for IronCross.
 */
const BetLimit_1 = require("../bets/BetLimit");
const CardVersionSetting_1 = require("../enums/CardVersionSetting");
const defaultOptions_1 = require("./defaultOptions");
exports.IronCrossOptions = {
    versions: [
        {
            title: "7 Card",
            description: "4 Player Cards, 3 Community Cards",
            value: CardVersionSetting_1.CardVersionSetting.SEVEN_CARD,
            flavor: 4,
            default: true,
            betLimit: BetLimit_1.BetLimit.SPREAD_LIMIT,
        },
        {
            title: "5 Card",
            description: "2 Player Cards, 3 Community Cards",
            flavor: 2,
            value: CardVersionSetting_1.CardVersionSetting.FIVE_CARD,
            betLimit: BetLimit_1.BetLimit.SPREAD_LIMIT,
        },
    ],
    winners: [defaultOptions_1.winnerHighOnlyDefault, defaultOptions_1.winnerLowOnly, defaultOptions_1.winnerHighLowSplit],
    options: [defaultOptions_1.optionNoneDefault],
    wildcards: [
        defaultOptions_1.wildcardNoneDefault,
        defaultOptions_1.wildcardCenterCard,
        defaultOptions_1.wildcardDeuces,
        defaultOptions_1.wildcardOneEyedJacks,
    ],
};
//# sourceMappingURL=IronCrossOptions.js.map